module.exports = __webpack_public_path__ + "static/img/e4.4b29422.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/e4.jpeg
// module id = BIpC
// module chunks = 1